import { render, staticRenderFns } from "./veStuIdxStuScoreEdit.vue?vue&type=template&id=c016bea0&scoped=true"
import script from "./veStuIdxStuScoreEdit.vue?vue&type=script&lang=js"
export * from "./veStuIdxStuScoreEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c016bea0",
  null
  
)

export default component.exports